module.exports = __webpack_public_path__ + "img/logo.9b04ea2b.png";